import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { mapValues, pick } from 'lodash';

import { updateCategoryMetadata } from '../services/api/categories';
import { CategoriesSearch } from '../components/PresetPicker/CategoriesSearch/CategoriesSearch';
import { CategoryForm } from '../components/CategoryForm/CategoryForm';
import { Form } from '../components/Form/Form';
import { useCategory } from '../hooks/useCategory';
import { withFetchStatus } from '../services/notifier';

import type { SvpCategory } from '../types';
import type { FC } from 'react';

export const Category: FC = () => {
  const navigate = useNavigate();
  const { categoryId } = useParams<{ categoryId: string }>();

  const {
    data: entity,
    isFetching,
    refetch,
  } = useCategory(categoryId ? parseInt(categoryId, 10) : undefined);

  const onCategoryClick = function (category: SvpCategory) {
    navigate(`/categories/${category.id}`, { replace: true });
  };

  async function onSubmit(category: SvpCategory) {
    await withFetchStatus(updateCategoryMetadata, {
      success: 'Category updated',
      error: 'Failed to update category',
    })(
      entity!.id,
      mapValues(
        pick(category.additional?.metadata, ['verticalPoster']),
        ({ value, inherited }) => (inherited ? undefined : value)
      )
    );

    await refetch();
  }

  if (!categoryId) {
    return (
      <Form initialValues={{}}>
        <CategoriesSearch
          selectedCategories={[]}
          onAddClick={onCategoryClick}
        />
      </Form>
    );
  }

  if (!entity) {
    return null;
  }

  return (
    <CategoryForm
      category={entity}
      onSubmit={onSubmit}
      isLoading={isFetching}
    />
  );
};
